var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{key:_vm.event.event_id},_vm._l((_vm.vals),function(val){return _c('div',{key:val.text,staticClass:"d-flex px-3"},[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(val.text))]),_c('div',{staticClass:"ml-3"},[_vm._v(_vm._s(val.val))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }